"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonImageAltText = exports.classes = void 0;
var classes = {
  // add bds
  previewContainer: 'bds-file-viewer-preview-container',
  previewImageContainer: 'bds-file-viewer-preview-image-container',
  previewFileName: 'bds-file-viewer-preview-file-name',
  previewDownload: 'bds-file-viewer-preview-download',
  previewNonImageContainer: 'bds-file-viewer-preview-non-image-files',
  fullScreenContainer: 'bds-file-viewer-full-screen-container',
  fullScreenTopPanel: 'bds-file-viewer-full-screen-top-panel',
  fullScreenTopPanelName: 'bds-file-viewer-full-screen-top-panel--file-name',
  fullScreenTopPanelNameText: 'bds-file-viewer-fullscreen-top-panel--file-name-text',
  fullScreenTopPanelNameTypeSize: 'bds-file-viewer-fullscreen-top-panel--file-name-type-size',
  fullScreenTopPanelNameButtons: 'bds-file-viewer-full-screen-top-panel--buttons',
  fullscreenTopPanelCloseFile: 'bds-file-viewer-full-screen-top-panel-close-file',
  fullScreenBottomPanel: 'bds-file-viewer-full-screen-bottom-panel',
  fullScreenBottomPanelZoom: 'bds-file-viewer-full-screen-bottom-panel--zoom',
  fullScreenBottomPanelZoomIn: 'bds-file-viewer-full-screen-bottom-panel--zoom-in',
  fullScreenBottomPanelZoomOut: 'bds-file-viewer-full-screen-bottom-panel-zoom-out',
  fullScreenBottomPanelZoomPercentage: 'bds-file-viewer-full-screen-bottom-panel-zoom-percentage',
  fullScreenImage: 'bds-file-viewer-full-screen-image'
};
exports.classes = classes;
var nonImageAltText = 'file';
exports.nonImageAltText = nonImageAltText;